import { createSlice } from "@reduxjs/toolkit";
import { showNotification } from "./notificationSlice";
import { factory } from "../../api/apiFactory";
import axios from "axios";

const profileApi = factory.get("profile");

const initialState = {
  user: {
    loading: false,
    info: {
      id: "",
      first_name: "",
      full_name: "",
      email: "",
      hired_date: "",
      phone_no1: "",
      phone_no2: "",
      start_time: "",
      end_time: "",
      day_off: "",
      job_title_histories: "",
      mother_name: "",
      spouse_name: "",
      birth_date: "",
      has_team: false,
      city: "",
      district: "",
      street: "",
      home: "",
      active: "",
      fingerprint_id: "",
      attachments: "",
      is_remotely: false,
      profile_pic: "",
      note: "",
      province: "",
      department: "",
      job_title: "",
      roles: "",
      salary: 0,
      evaluation_average: null,
      evaluation_month: null,
    },
  },
};

export const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state[action.payload].loading = !state[action.payload].loading;
    },
    setProfile: (state, { payload }) => {
      state.user.info = {
        ...state.user.info,
        ...payload,
      };

      const profile_pic = payload.attachments.filter(
        (item) => item.tag === "profile_pic"
      );

      if (profile_pic.length > 0) {
        state.user.info.profile_pic = profile_pic[0].path;
      }
    },
    setProfilePicture: (state, { payload }) => {
      state.user.info.profile_pic = payload;
    },
  },
});

export const { setProfile, setProfilePicture, setLoading } =
  profileSlice.actions;

export default profileSlice.reducer;

//axios
export const Profile = {
  myInfo: (data) => async (dispatch) => {
    try {
      dispatch(setLoading("user"));
      const res = await profileApi.info();
      dispatch(setProfile(res.data.data[0]));
      dispatch(setLoading("user"));
    } catch (err) {
      dispatch(setLoading("user"));
      throw new Error(err);
    }
  },
  profilePicture: (profile_pic) => async (dispatch) => {
    try {
      dispatch(setLoading("user"));

      const formData = new FormData();

      formData.append("profile_pic", profile_pic);
      formData.append("mobile", true);

      // for (var pair of formData.entries()) {
      //     console.log(pair[0] + ', ' + pair[1]);
      // }

      // console.log(profile_pic)

      const res = await profileApi.profilePicture(formData);

      dispatch(setProfilePicture(res.data.data[0].profile_pic.path));

      dispatch(
        showNotification({
          message: res.data.message,
          type: "success",
        })
      );
      dispatch(setLoading("user"));
      return {
        status: true,
      };
    } catch (err) {
      dispatch(setLoading("user"));
      throw new Error(err);
    }
  },
};
